import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";
import { FAQS, REGISTRATION_CARDS, TERMS_AND_CONDITION } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const desktopBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio+State/FB_2026StudentTickets_1920x450.jpg";
const mobileBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio+State/FB_2026StudentTickets_375x550.jpg";

export const buckeyes_indianaaway: TTeamConfig = {
  TEAM_SCHEMA: "buckeyes_indianaaway",
  TEAM_FULL_NAME: "Ohio State University",
  BROWSER_TITLE: "Ohio State Student Tickets",
  CLIENT_ID: "332b7a436b2b.seasonshare.buckeyes-buckeyes.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/buckeyes/",
    COLORS_PRIMARY: "#ba0c2f",
    COLORS_SECONDARY: "#a7b1b7",
    DEFAULT_APP_ROUTE: routes.my_group,
    DEFAULT_APP_ROUTE_AFTER_LOGIN: routes.my_group,
    IS_CROWD_HANDLER_ENABLED: true,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_PURCHASE_HISTORY: true,
    },

    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      SECTION_TITLE: "Student Tickets",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio-State-Buckeyes.png",
    LANDING_PAGE_STATIC_BANNER_URL: desktopBannerUrl,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileBannerUrl,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: desktopBannerUrl,
    ORDER_SUMMERY_BACKGROUND_URL: desktopBannerUrl,
  },

  LANGUAGES: {
    FAQS,
  },
};
